module.exports = __webpack_public_path__ + "static/media/wood.0be6f990.png";